import Client from 'shopify-buy';

const accessToken = 'f1fd657a0b27209152e703c1d1b6903c';
const domain = 'bw-restaurants-oy';
const appId = '329809921';

export const shopClient = Client.buildClient({
  accessToken: accessToken,
  domain: domain+'.myshopify.com',
  appId: appId
});

export const getProductsInCollection = (collection) =>
  shopClient.fetchQueryProducts({ collection_id: collection })
  .then(response => response)
  .catch(function () {
    console.log('Request failed');
  });


// WEBPACK FOOTER //
// ./src/api/shopifyAPI.js